module.exports = __webpack_public_path__ + "img/POP-00010-2.98fcec23.png";